import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
  reloadTableQuotes: ['data']
});

const INITIAL_STATE: { reload: boolean; } = { reload: false };

const reloadTableQuotes = (state = INITIAL_STATE, action: any) => ({ ...action.data });

export default createReducer(INITIAL_STATE, {
  [Types.RELOAD_TABLE_QUOTES as any]: reloadTableQuotes
});
